'use client';

import { MaterialIconName } from '../../types/materialIconName';
import {
  getClientTranslations,
  TranslContext,
} from '../../utils/translations/getClientTranslations';
import { tr } from '../../utils/translations/tr';
import { CollapsibleSection } from '../CollapsibleSection/CollapsibleSection';
import { RichText } from '../RichText';
import { TranslationKey, TRANSLATIONS } from './i18n';

export type PromoDetailsCIProps = {
  title: string;
  icon: MaterialIconName | undefined;
  content: string;
  isVisible: boolean;
  translationContext: TranslContext;
  toggleVisibility: () => void;
};

export const PromoDetailsCI: React.FC<PromoDetailsCIProps> = ({
  icon,
  content,
  isVisible,
  title,
  translationContext,
  toggleVisibility,
}) => {
  const key = title as TranslationKey;
  const staticText = getClientTranslations(TRANSLATIONS, translationContext);

  return (
    <CollapsibleSection
      id={`promo-details-ci-${title}`}
      isOpen={isVisible}
      onToggle={toggleVisibility}
      iconName={icon}
      iconClassName="overflow-visible size-[18px] md:size-[22px] md:mb-0 md:mr-2"
      content={
        <div className="p-3">
          <div className="grid grid-cols-1 gap-spacing/gap/soft-12px font-medium text-sm lg:text-base"></div>
          {content && (
            <RichText className="w-full overflow-x-hidden">
              {content ?? ''}
            </RichText>
          )}
        </div>
      }
    >
      <span className="mhg-alpha-bullet-2 lg:mhg-alpha-bullet-1">
        {key in staticText ? tr(key, staticText) : title}
      </span>
    </CollapsibleSection>
  );
};
